import React from "react";
import AddReduceBtn from "../../../../../../../UI/AddReduceBtn"
import { removeDish, addDishToOrder, removeAllDishes } from "../../../../../slices/OrdersFeedSlice";
import { useDispatch } from "react-redux";

const DishOrder = ({ dish }) => {
    const dispatch = useDispatch();

    const handleRemoveFromCart = (dishName) => {
        dispatch(removeDish(dishName));
    }

    const handleAddToOrder = () => {
        dispatch(addDishToOrder(dish));
    }

    const handleRemoveAllFromCart = () => {
        dispatch(removeAllDishes(dish.name));
    }

    return(
        <div className="rounded-2xl bg-zinc-400 dark:bg-zinc-800 py-3.5 px-5 space-y-5 shadow-md border border-zinc-400 dark:border-zinc-900">
            <div className="flex flex-col">
                <div className="flex flex-row justify-between">
                    <p className="text-black dark:text-white text-md font-medium">{dish.name}</p>
                    <svg onClick={handleRemoveAllFromCart} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-black dark:text-white hover:text-red-500 duration-150 cursor-pointer">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                    </svg>
                </div>
                <p className="text-zinc-700 dark:text-zinc-500 text-md font-medium">$ {dish.price}</p>
            </div>
            <div className="flex flex-row space-x-3">
                <AddReduceBtn action="+" color="text-zinc-800 dark:text-white" bgColor="bg-zinc-500 dark:bg-zinc-700" hoverBg="hover:bg-zinc-600" onClick={() => handleAddToOrder(dish)}/>
                <p className="flex items-center text-white font-semibold">{dish.quantity}</p> 
                <AddReduceBtn action="-" color="text-zinc-800 dark:text-white" bgColor="bg-zinc-500 dark:bg-zinc-700" hoverBg="hover:bg-zinc-600" onClick={() => handleRemoveFromCart(dish.name)}/>
            </div>
        </div>
    );
}

export default DishOrder;